/**
 * @author PoornaChandu
 * @description added FieldDataType and Observation Type
 */
/* eslint-disable no-unused-vars */
import React, { Fragment, useState, useEffect } from 'react';
import {
  Form,
  Button,
  Select,
  Popconfirm,
  Collapse,
  Tooltip,
  Input,
  Checkbox,
  message
} from 'antd';
import { DeleteOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import {
  getToolsList,
  getLaborList,
  getMaterialsList,
  checkTask,
  getItemsList,
  getSkillTypeList,
  _getUOMList,
  getUsersList
} from '../../../Utils/FormCalls';
import translation from '../../../../../commons/translation';
import { connect } from 'react-redux';
import themeSettings from '../../../../../commons/styles/themeSettings.json';
import { constant } from '../../../Utils/constants';
import InputComponent from '../../../Widgets/InputComponent';
import InputNumberComponent from '../../../Widgets/InputNumberComponent';
import { StyledBox } from '../../../CSS/style';
const { Option } = Select;
const { Panel } = Collapse;
const { TextArea } = Input;

const ToolsformFunction = (props) => {
  const [toolsList, setTool] = useState([]);
  const [translationCache, settranslationCache] = useState(props.translationCache || {});
  useEffect(() => {
    (async () => {
      try {
        let response = await getToolsList();

        setTool(response.data);
      } catch (e) {
        return {};
      }
    })();
  }, []);

  return (
    <Form.List name={[props.fieldKey, 'Tools']}>
      {(Tools, { add, remove }) => {
        return (
          <Fragment>
            <Form.Item>
              
                <div style={{ display: 'flex', justifyContent: 'right' }}>
                <Button
                  theme={themeSettings}
                  type="primary"
                  onClick={() => {
                    add();
                  }}
                >
                  {' '}
                  {translation(translationCache, constant.addTools)}{' '}
                </Button>
              </div>
            </Form.Item>
            {Tools && Array.isArray(Tools) && Tools.length > 0 ? (
              <Collapse theme={themeSettings} accordion defaultActiveKey={[]}>
                {Tools.map((tool, index2) => (
                  <Panel
                    key={index2}
                    header={`${translation(translationCache, constant.tools)} ${index2 + 1}`}
                    extra={
                      <Popconfirm
                        title={translation(translationCache, constant.deleteTool)}
                        icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                        // onConfirm={() => remove(tool.name)}
                        onConfirm={() => remove(tool.name)}
                        okText={translation(translationCache, constant.yes)}
                        cancelText={translation(translationCache, constant.no)}
                      >
                        <Tooltip title={translation(translationCache, 'Delete')} placement="bottom">
                          <DeleteOutlined />
                        </Tooltip>
                      </Popconfirm>
                    }
                  >
                    <>
                      <StyledBox>
                        <Form.Item

                          label={translation(translationCache, constant.tool)}
                          {...tool}
                          name={[tool.name, 'ToolId']}
                          fieldKey={[tool.fieldKey, 'ToolId']}
                          key={index2}
                          rules={[{ required: true, message: 'tool Missing' }]}
                        >
                          <Select
                            style={{ width: '100%' }}
                            onChange={(value) =>
                              props.onToolChange(
                                value,
                                props.fieldKey,
                                tool.key,
                                'Tools',
                                toolsList.filter((tool) => tool.Id === value)
                              )
                            }
                            placeholder={translation(translationCache, 'Select Tool')}
                          >
                            {toolsList.map((tool, index) => {
                              return (
                                <Option
                                  key={index}
                                  value={tool.Id}
                                  disabled={
                                    props && props.selectedTab && props.selectedTab !== '2'
                                      ? props &&
                                        props.formObject &&
                                        props.formObject.TaskData &&
                                        props.formObject.TaskData[props.fieldKey] &&
                                        props.formObject.TaskData[props.fieldKey].Tools &&
                                        props.formObject.TaskData[props.fieldKey].Tools.filter(
                                          (item) => item && item.ToolId === tool.Id
                                        ).length > 0
                                        ? true
                                        : false
                                      : props &&
                                        props.formObject &&
                                        props.formObject.ActualTaskData &&
                                        props.formObject.ActualTaskData[props.fieldKey] &&
                                        props.formObject.ActualTaskData[props.fieldKey].Tools &&
                                        props.formObject.ActualTaskData[
                                          props.fieldKey
                                        ].Tools.filter((item) => item && item.ToolId === tool.Id)
                                          .length > 0
                                        ? true
                                        : false
                                  }
                                >
                                  {' '}
                                  {tool.Tool}{' '}
                                </Option>
                              );
                            })}
                          </Select>
                        </Form.Item>
                        <Form.Item
                          label={translation(translationCache, constant.description)}
                          {...tool}

                          name={[tool.name, 'Description']}
                          fieldKey={[tool.fieldKey, 'Description']}
                          key={index2}
                          rules={[{ required: false, message: 'Value Missing' }]}
                        >
                          <InputComponent
                            placeholder={translation(translationCache, 'Description')}
                            style={{ width: '100%' }}
                            value={toolsList.Description}
                            disabled
                          />
                        </Form.Item>

                        {props && props.selectedTab && props.selectedTab === '1' ? (
                          <Form.Item
                            label={translation(translationCache, constant.Quantity)}
                            disabled={true}
                            validateTrigger={['onChange', 'onBlur']}
                            {...tool}
                            name={[tool.name, 'Quantity']}
                            fieldKey={[tool.fieldKey, 'Quantity']}
                            key={index2}
                            rules={[
                              { required: false, message: 'Please Input Numbers Only' },
                              {
                                validator: (_, value) =>
                                  checkTask(
                                    _,
                                    value,
                                    'Tools',
                                    tool.key,
                                    props.formObject.TaskData[props.fieldKey],
                                    { validateDecimal: true }
                                  )
                              }
                            ]}
                          >
                            <InputNumberComponent
                              // min={0}
                              // max={1000}
                              placeholder={translation(translationCache, 'Quantity')}
                              style={{ width: '100%' }}
                              disabled={
                                (props &&
                                  props.formObject &&
                                  props.formObject.TaskData &&
                                  props.formObject.TaskData[props.fieldKey] &&
                                  props.formObject.TaskData[props.fieldKey].Tools &&
                                  props.formObject.TaskData[props.fieldKey].Tools[index2] ===
                                  null) ||
                                  (props &&
                                    props.formObject &&
                                    props.formObject.TaskData &&
                                    props.formObject.TaskData[props.fieldKey] &&
                                    props.formObject.TaskData[props.fieldKey].Tools &&
                                    props.formObject.TaskData[props.fieldKey].Tools[index2] ===
                                    undefined)
                                  ? true
                                  : false
                              }
                              addonAfter={
                                <Tooltip
                                  style={{ marginRight: '20px', flex: '50%' }}
                                  labelCol={{ flex: '130px' }}
                                  title={translation(
                                    translationCache,
                                    'AvailableQuantity  -  ' +
                                    (props &&
                                      props.formObject &&
                                      props.formObject.TaskData &&
                                      props.formObject.TaskData[props.fieldKey] &&
                                      props.formObject.TaskData[props.fieldKey].Tools &&
                                      props.formObject.TaskData[props.fieldKey].Tools[index2] &&
                                      props.formObject.TaskData[props.fieldKey].Tools[index2]
                                        .AvailableQuantity
                                      ? props.formObject.TaskData[props.fieldKey].Tools[index2]
                                        .AvailableQuantity
                                      : 'Not Available')
                                  )}
                                >
                                  <QuestionCircleOutlined style={{ fontSize: '25px' }} />
                                </Tooltip>
                              }
                            />
                          </Form.Item>
                        ) : (
                          <Form.Item
                            label={translation(translationCache, constant.Quantity)}
                            validateTrigger={['onChange', 'onBlur']}
                            {...tool}
                            name={[tool.name, 'Quantity']}
                            fieldKey={[tool.fieldKey, 'Quantity']}
                            key={index2}
                            rules={[
                              { required: false, message: 'Please Input Numbers Only' },
                              {
                                validator: (_, value) =>
                                  checkTask(
                                    _,
                                    value,
                                    'Tools',
                                    tool.key,
                                    props.formObject.ActualTaskData[props.fieldKey],
                                    { validateDecimal: true }
                                  )
                              }
                            ]}
                          >
                            <InputNumberComponent
                              // min={0}
                              // max={1000}
                              placeholder={translation(translationCache, 'Quantity')}
                              style={{ width: '100%' }}
                              disabled={
                                (props &&
                                  props.formObject &&
                                  props.formObject.ActualTaskData &&
                                  props.formObject.ActualTaskData[props.fieldKey] &&
                                  props.formObject.ActualTaskData[props.fieldKey].Tools &&
                                  props.formObject.ActualTaskData[props.fieldKey].Tools[index2] ===
                                  null) ||
                                  (props &&
                                    props.formObject &&
                                    props.formObject.ActualTaskData &&
                                    props.formObject.ActualTaskData[props.fieldKey] &&
                                    props.formObject.ActualTaskData[props.fieldKey].Tools &&
                                    props.formObject.ActualTaskData[props.fieldKey].Tools[index2] ===
                                    undefined)
                                  ? true
                                  : false
                              }
                              addonAfter={
                                <Tooltip
                                  style={{ marginRight: '20px', flex: '50%' }}
                                  labelCol={{ flex: '130px' }}
                                  title={translation(
                                    translationCache,
                                    'AvailableQuantity  -  ' +
                                    (props &&
                                      props.formObject &&
                                      props.formObject.ActualTaskData &&
                                      props.formObject.ActualTaskData[props.fieldKey] &&
                                      props.formObject.ActualTaskData[props.fieldKey].Tools &&
                                      props.formObject.ActualTaskData[props.fieldKey].Tools[
                                      index2
                                      ] &&
                                      props.formObject.ActualTaskData[props.fieldKey].Tools[index2]
                                        .AvailableQuantity
                                      ? props.formObject.ActualTaskData[props.fieldKey].Tools[
                                        index2
                                      ].AvailableQuantity
                                      : 'Not Available')
                                  )}
                                >
                                  <QuestionCircleOutlined style={{ fontSize: '25px' }} />
                                </Tooltip>
                              }
                            />
                          </Form.Item>
                        )}
                        <Form.Item
                          name={[tool.name, 'AvailableQuantity']}
                        />
                      </StyledBox>
                    </>
                  </Panel>
                ))}
              </Collapse>
            ) : null}
          </Fragment>
        );
      }}
    </Form.List>
  );
};
const LaborFormFunction = (props) => {
  const [laborsList, setLabor] = useState([]);
  const [SkilTypeList, setSkill] = useState([]);
  const [translationCache, settranslationCache] = useState(props.translationCache || {});
  useEffect(() => {
    (async () => {
      try {
        let response = await getLaborList();
        setLabor(response.data);
      } catch (e) {
        return {};
      }
      try {
        let SkilTypeList = await getSkillTypeList();
        setSkill(SkilTypeList);
      } catch (e) {
        return {};
      }
    })();
  }, []);
  const isLaborSelected = (laborId, taskData) => {
    return (
      taskData &&
      taskData['Labor'] &&
      taskData['Labor'].some((item) => item && item.LaborId === laborId)
    );
  };
  const isDisabled = () => {
    if (!props || !props.formObject) return false;
    const { selectedTab, formObject } = props;
    const taskData =
      selectedTab && selectedTab !== '2'
        ? formObject.TaskData[props.fieldKey]
        : formObject.ActualTaskData[props.fieldKey];
    return isLaborSelected(laborsList.Id, taskData);
  };
  return (
    <div>
      <Form.List name={[props.fieldKey, 'Labor']}>
        {(Labor, { add, remove }) => {
          return (
            <Fragment>
              <Form.Item>
               
                <div style={{ display: 'flex', justifyContent: 'right' }}>
                  <Button
                    theme={themeSettings}
                    type="primary"
                    onClick={() => {
                      add();
                    }}
                  >
                    {translation(translationCache, constant.addLabor)}{' '}
                  </Button>{' '}
                </div>
              </Form.Item>
              {Labor && Array.isArray(Labor) && Labor.length > 0 ? (
                <Collapse theme={themeSettings} accordion defaultActiveKey={[]}>
                  {Labor.map((labor, index2) => (
                    <Panel
                      key={index2}
                      header={`${translation(translationCache, constant.labor)} ${index2 + 1}`}
                      extra={
                        <Popconfirm
                          title={translation(translation, constant.deleteLabor)}
                          icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                          // onConfirm={() => remove(labor.name)}
                          onConfirm={() => remove(labor.name)}
                          okText={translation(translationCache, constant.yes)}
                          cancelText={translation(translationCache, constant.no)}
                        >
                          <Tooltip
                            title={translation(translationCache, 'Delete')}
                            placement="bottom"
                          >
                            <DeleteOutlined />
                          </Tooltip>
                        </Popconfirm>
                      }
                    >
                      <>
                        <StyledBox>
                          <Form.Item

                            label={translation(translationCache, constant.labor)}
                            {...labor}
                            name={[labor.name, 'LaborId']}
                            fieldKey={[labor.fieldKey, 'LaborId']}
                            key={index2}
                            rules={[{ required: true, message: 'Labor required' }]}
                          >
                            <Select
                              style={{ width: '100%' }}
                              onChange={(value) =>
                                props.onLaborChange(
                                  value,
                                  props.fieldKey,
                                  labor.key,
                                  'Labor',
                                  laborsList.filter((laborItem) => laborItem.Id === value)
                                )
                              }
                              placeholder={translation(translationCache, 'Select Manpower')}
                            >
                              {laborsList &&
                                Array.isArray(laborsList) &&
                                laborsList.map((labor, index) => {
                                  return (
                                    <Option key={index} value={labor.Id} disabled={isDisabled()}>
                                      {labor.FirstName}
                                    </Option>
                                  );
                                })}
                            </Select>
                          </Form.Item>
                          <Form.Item

                            label={translation(translationCache, constant.Skill)}
                            {...labor}
                            name={[labor.name, 'SkillTypeId']}
                            fieldKey={[labor.fieldKey, 'SkillTypeId']}
                            key={index2}
                            rules={[{ required: false, message: 'SkillType Missing' }]}
                          >
                            <Select
                              style={{
                                width: '100%'
                                // cursor: 'not-allowed',
                                // opacity: '0.8'
                              }}
                              placeholder={translation(
                                translationCache,
                                'Autopopulated based on Manpower'
                              )}
                              disabled
                            >
                              {SkilTypeList &&
                                Array.isArray(SkilTypeList) &&
                                SkilTypeList.map((skill, index) => {
                                  return (
                                    <Option key={index} value={skill.Id}>
                                      {' '}
                                      {skill.Type}{' '}
                                    </Option>
                                  );
                                })}
                            </Select>
                          </Form.Item>

                          {props && props.selectedTab && props.selectedTab === '1' ? (
                            <Form.Item
                              label={translation(translationCache, constant.Quantity)}
                              validateTrigger={['onChange', 'onBlur']}
                              {...labor}
                              name={[labor.name, 'Quantity']}
                              fieldKey={[labor.fieldKey, 'Quantity']}
                              key={index2}
                              rules={[
                                { required: false, message: 'Please Input Numbers Only' },
                                {
                                  validator: (_, value) =>
                                    checkTask(
                                      _,
                                      value,
                                      'Labor',
                                      labor.key,
                                      props.formObject.TaskData[props.fieldKey],
                                      { validateDecimal: true }
                                    )
                                }
                              ]}
                            >
                              <InputNumberComponent
                                placeholder={translation(translationCache, 'Quantity')}
                                style={{ width: '100%' }}
                                disabled={
                                  (props &&
                                    props.formObject &&
                                    props.formObject.TaskData &&
                                    props.formObject.TaskData[props.fieldKey] &&
                                    props.formObject.TaskData[props.fieldKey].Labor &&
                                    props.formObject.TaskData[props.fieldKey].Labor[index2] ===
                                    null) ||
                                    (props &&
                                      props.formObject &&
                                      props.formObject.TaskData &&
                                      props.formObject.TaskData[props.fieldKey] &&
                                      props.formObject.TaskData[props.fieldKey].Labor &&
                                      props.formObject.TaskData[props.fieldKey].Labor[index2] ===
                                      undefined)
                                    ? true
                                    : false
                                }
                                addonAfter={
                                  <Tooltip
                                    style={{ marginRight: '20px', flex: '50%' }}
                                    labelCol={{ flex: '130px' }}
                                    title={translation(
                                      translationCache,
                                      'AvailableQuantity  -  ' +
                                      (props &&
                                        props.formObject &&
                                        props.formObject.TaskData &&
                                        props.formObject.TaskData[props.fieldKey] &&
                                        props.formObject.TaskData[props.fieldKey].Labor &&
                                        props.formObject.TaskData[props.fieldKey].Labor[index2] &&
                                        props.formObject.TaskData[props.fieldKey].Labor[index2]
                                          .AvailableQuantity
                                        ? props.formObject.TaskData[props.fieldKey].Labor[index2]
                                          .AvailableQuantity
                                        : 'Not Available')
                                    )}
                                  >
                                    <QuestionCircleOutlined style={{ fontSize: '25px' }} />
                                  </Tooltip>
                                }
                              />
                            </Form.Item>
                          ) : (
                            <Form.Item
                              label={translation(translationCache, constant.Quantity)}
                              validateTrigger={['onChange', 'onBlur']}
                              {...labor}
                              name={[labor.name, 'Quantity']}
                              fieldKey={[labor.fieldKey, 'Quantity']}
                              key={index2}
                              rules={[
                                { required: false, message: 'Please Input Numbers Only' },
                                {
                                  validator: (_, value) =>
                                    checkTask(
                                      _,
                                      value,
                                      'Labor',
                                      labor.key,
                                      props.formObject.ActualTaskData[props.fieldKey],
                                      { validateDecimal: true }
                                    )
                                }
                              ]}
                            >
                              <InputNumberComponent
                                placeholder={translation(translationCache, 'Quantity')}
                                style={{ width: '100%' }}
                                disabled={
                                  (props &&
                                    props.formObject &&
                                    props.formObject.ActualTaskData &&
                                    props.formObject.ActualTaskData[props.fieldKey] &&
                                    props.formObject.ActualTaskData[props.fieldKey].Labor &&
                                    props.formObject.ActualTaskData[props.fieldKey].Labor[
                                    index2
                                    ] === null) ||
                                    (props &&
                                      props.formObject &&
                                      props.formObject.ActualTaskData &&
                                      props.formObject.ActualTaskData[props.fieldKey] &&
                                      props.formObject.ActualTaskData[props.fieldKey].Labor &&
                                      props.formObject.ActualTaskData[props.fieldKey].Labor[
                                      index2
                                      ] === undefined)
                                    ? true
                                    : false
                                }
                                addonAfter={
                                  <Tooltip
                                    style={{ marginRight: '20px', flex: '50%' }}
                                    labelCol={{ flex: '130px' }}
                                    title={translation(
                                      translationCache,
                                      'AvailableQuantity  -  ' +
                                      (props &&
                                        props.formObject &&
                                        props.formObject.ActualTaskData &&
                                        props.formObject.ActualTaskData[props.fieldKey] &&
                                        props.formObject.ActualTaskData[props.fieldKey].Labor &&
                                        props.formObject.ActualTaskData[props.fieldKey].Labor[
                                        index2
                                        ] &&
                                        props.formObject.ActualTaskData[props.fieldKey].Labor[
                                          index2
                                        ].AvailableQuantity
                                        ? props.formObject.ActualTaskData[props.fieldKey].Labor[
                                          index2
                                        ].AvailableQuantity
                                        : 'Not Available')
                                    )}
                                  >
                                    <QuestionCircleOutlined style={{ fontSize: '25px' }} />
                                  </Tooltip>
                                }
                              />
                            </Form.Item>
                          )}

                          <Form.Item
                            name={[labor.name, 'AvailableQuantity']}
                          >
                          </Form.Item>
                        </StyledBox>
                      </>
                    </Panel>
                  ))}
                </Collapse>
              ) : null}
            </Fragment>
          );
        }}
      </Form.List>
    </div>
  );
};
const MaterialFormFunction = (props) => {
  const [materialsList, setTool] = useState([]);
  const [translationCache, settranslationCache] = useState(props.translationCache || {});
  useEffect(() => {
    (async () => {
      try {
        let response = await getMaterialsList();
        setTool(response.data);
      } catch (e) {
        return {};
      }
    })();
  }, []);
  return (
    <div>
      <Form.List name={[props.fieldKey, 'Materials']}>
        {(Material, { add, remove }) => {
          return (
            <Fragment>
              <Form.Item>

                <div style={{ display: 'flex', justifyContent: 'right' }}>                  
                  <Button
                    theme={themeSettings}
                    type="primary"
                    onClick={() => {
                      add();
                    }}
                  >
                    {translation(translationCache, constant.addMaterial)}{' '}
                  </Button>
                </div>
              </Form.Item>
              {Material && Array.isArray(Material) && Material.length > 0 ? (
                <Collapse theme={themeSettings} accordion defaultActiveKey={[]}>
                  {Material.map((material, index2) => (
                    <Panel
                      key={index2}
                      header={`${translation(translationCache, constant.material)} ${index2 + 1}`}
                      extra={
                        <Popconfirm
                          title={translation(translationCache, constant.deleteMaterial)}
                          icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                          // onConfirm={() => remove(material.name)}
                          onConfirm={() => remove(material.name)}
                          okText={translation(translationCache, constant.yes)}
                          cancelText={translation(translationCache, constant.no)}
                        >
                          <Tooltip
                            title={translation(translationCache, 'Delete')}
                            placement="bottom"
                          >
                            <DeleteOutlined />
                          </Tooltip>
                        </Popconfirm>
                      }
                    >
                      <>
                        <StyledBox>
                          <Form.Item

                            label={translation(translationCache, constant.material)}
                            {...material}
                            name={[material.name, 'MaterialId']}
                            fieldKey={[material.fieldKey, 'MaterialId']}
                            key={index2}
                            rules={[{ required: true, message: 'Material is required' }]}
                          >
                            <Select
                              style={{ width: '100%' }}
                              onChange={(value) =>
                                props.onMaterialChange(
                                  value,
                                  props.fieldKey,
                                  material.key,
                                  'Materials',
                                  materialsList.filter((Item) => Item.Id === value)
                                )
                              }
                              placeholder={translation(translationCache, 'Select Material')}
                            >
                              {materialsList.map((material, index) => {
                                return (
                                  <Option
                                    key={index}
                                    value={material.Id}
                                    disabled={
                                      props && props.selectedTab && props.selectedTab !== '2'
                                        ? props &&
                                          props.formObject &&
                                          props.formObject.TaskData &&
                                          props.formObject.TaskData[props.fieldKey] &&
                                          props.formObject.TaskData[props.fieldKey]['Materials'] &&
                                          props.formObject.TaskData[props.fieldKey][
                                            'Materials'
                                          ].filter(
                                            (item) => item && item.MaterialId === material.Id
                                          ).length > 0
                                          ? true
                                          : false
                                        : props &&
                                          props.formObject &&
                                          props.formObject.ActualTaskData &&
                                          props.formObject.ActualTaskData[props.fieldKey] &&
                                          props.formObject.ActualTaskData[props.fieldKey][
                                          'Materials'
                                          ] &&
                                          props.formObject.ActualTaskData[props.fieldKey][
                                            'Materials'
                                          ].filter(
                                            (item) => item && item.MaterialId === material.Id
                                          ).length > 0
                                          ? true
                                          : false
                                    }
                                  >
                                    {' '}
                                    {material.Material}{' '}
                                  </Option>
                                );
                              })}
                            </Select>
                          </Form.Item>
                          <Form.Item
                            label={translation(translationCache, constant.description)}
                            {...material}
                            name={[material.name, 'Description']}
                            fieldKey={[material.fieldKey, 'Description']}
                            key={index2}
                            rules={[{ required: false, message: 'Value Missing' }]}
                          >
                            <InputComponent
                              placeholder={translation(translationCache, 'Description')}
                              style={{ width: '100%' }}
                              disabled
                            />
                          </Form.Item>
                          
                          {props && props.selectedTab && props.selectedTab === '1' ? (
                            <Form.Item
                              label={translation(translationCache, constant.Quantity)}
                              validateTrigger={['onChange', 'onBlur']}
                              {...material}
                              name={[material.name, 'Quantity']}
                              fieldKey={[material.fieldKey, 'Quantity']}
                              key={index2}
                              rules={[
                                { required: false, message: 'Please Input Numbers Only' },
                                {
                                  validator: (_, value) =>
                                    checkTask(
                                      _,
                                      value,
                                      'Materials',
                                      material.key,
                                      props.formObject.TaskData[props.fieldKey],
                                      { validateDecimal: true }
                                    )
                                }
                              ]}
                            >
                              <InputNumberComponent
                                placeholder={translation(translationCache, 'Quantity')}
                                style={{ width: '100%' }}
                                disabled={
                                  (props &&
                                    props.formObject &&
                                    props.formObject.TaskData &&
                                    props.formObject.TaskData[props.fieldKey] &&
                                    props.formObject.TaskData[props.fieldKey].Materials &&
                                    props.formObject.TaskData[props.fieldKey].Materials[index2] ===
                                    null) ||
                                    (props &&
                                      props.formObject &&
                                      props.formObject.TaskData &&
                                      props.formObject.TaskData[props.fieldKey] &&
                                      props.formObject.TaskData[props.fieldKey].Materials &&
                                      props.formObject.TaskData[props.fieldKey].Materials[index2] ===
                                      undefined)
                                    ? true
                                    : false
                                }
                                addonAfter={
                                  <Tooltip
                                    title={translation(
                                      translationCache,
                                      'AvailableQuantity  -  ' +
                                      (props &&
                                        props.formObject &&
                                        props.formObject.TaskData &&
                                        props.formObject.TaskData[props.fieldKey] &&
                                        props.formObject.TaskData[props.fieldKey].Materials &&
                                        props.formObject.TaskData[props.fieldKey].Materials[
                                        index2
                                        ] &&
                                        props.formObject.TaskData[props.fieldKey].Materials[index2]
                                          .AvailableQuantity
                                        ? props.formObject.TaskData[props.fieldKey].Materials[
                                          index2
                                        ].AvailableQuantity
                                        : 'Not Available')
                                    )}
                                  >
                                    <QuestionCircleOutlined style={{ fontSize: '25px' }} />
                                  </Tooltip>
                                }
                              />
                            </Form.Item>
                          ) : (
                            <Form.Item
                              label={translation(translationCache, constant.Quantity)}
                              validateTrigger={['onChange', 'onBlur']}
                              {...material}
                              name={[material.name, 'Quantity']}
                              fieldKey={[material.fieldKey, 'Quantity']}
                              key={index2}
                              rules={[
                                { required: false, message: 'Please Input Numbers Only' },
                                {
                                  validator: (_, value) =>
                                    checkTask(
                                      _,
                                      value,
                                      'Materials',
                                      material.key,
                                      props.formObject.ActualTaskData[props.fieldKey],
                                      { validateDecimal: true }
                                    )
                                }
                              ]}
                            >
                              <InputNumberComponent
                                placeholder={translation(translationCache, 'Quantity')}
                                style={{ width: '100%' }}
                                disabled={
                                  (props &&
                                    props.formObject &&
                                    props.formObject.ActualTaskData &&
                                    props.formObject.ActualTaskData[props.fieldKey] &&
                                    props.formObject.ActualTaskData[props.fieldKey].Materials &&
                                    props.formObject.ActualTaskData[props.fieldKey].Materials[
                                    index2
                                    ] === null) ||
                                    (props &&
                                      props.formObject &&
                                      props.formObject.ActualTaskData &&
                                      props.formObject.ActualTaskData[props.fieldKey] &&
                                      props.formObject.ActualTaskData[props.fieldKey].Tools &&
                                      props.formObject.ActualTaskData[props.fieldKey].Tools[
                                      index2
                                      ] === undefined)
                                    ? true
                                    : false
                                }
                                addonAfter={
                                  <Tooltip
                                    style={{ marginRight: '20px', flex: '50%' }}
                                    labelCol={{ flex: '130px' }}
                                    title={translation(
                                      translationCache,
                                      'AvailableQuantity  -  ' +
                                      (props &&
                                        props.formObject &&
                                        props.formObject.ActualTaskData &&
                                        props.formObject.ActualTaskData[props.fieldKey] &&
                                        props.formObject.ActualTaskData[props.fieldKey].Materials &&
                                        props.formObject.ActualTaskData[props.fieldKey].Materials[
                                        index2
                                        ] &&
                                        props.formObject.ActualTaskData[props.fieldKey].Materials[
                                          index2
                                        ].AvailableQuantity
                                        ? props.formObject.ActualTaskData[props.fieldKey]
                                          .Materials[index2].AvailableQuantity
                                        : 'Not Available')
                                    )}
                                  >
                                    <QuestionCircleOutlined style={{ fontSize: '25px' }} />
                                  </Tooltip>
                                }
                              />
                            </Form.Item>
                          )}
                        <Form.Item
                            name={[material.name, 'AvailableQuantity']} >
                          </Form.Item>
                        </StyledBox>
                      </>
                    </Panel>
                  ))}
                </Collapse>
              ) : null}
            </Fragment>
          );
        }}
      </Form.List>
    </div>
  );
};
const ItemFormFunction = (props) => {
  const [itemsList, setItem] = useState([]);
  const [translationCache, settranslationCache] = useState(props.translationCache || {});
  useEffect(() => {
    (async () => {
      try {
        let response = await getItemsList();
        setItem(response.data);
      } catch (e) {
        return {};
      }
    })();
  }, []);
  return (
    <Form.List name={[props.fieldKey, 'Items']}>
      {(Items, { add, remove }) => {
        return (
          <Fragment>
            <Form.Item>
              <div style={{ display: 'flex', justifyContent: 'right' }}>
                <Button
                  theme={themeSettings}
                  type="primary"
                  onClick={() => {
                    add();
                  }}
                >
                  {translation(translationCache, constant.addItem)}{' '}
                </Button>
              </div>
            </Form.Item>
            {Items && Array.isArray(Items) && Items.length > 0 ? (
              <Collapse theme={themeSettings} accordion defaultActiveKey={[]}>
                {Items.map((item, index2) => (
                  <Panel
                    key={index2}
                    header={`${translation(translationCache, constant.item)} ${index2 + 1}`}
                    extra={
                      <Popconfirm
                        title={translation(translationCache, constant.deleteItem)}
                        icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                        // onConfirm={() => remove(item.name)}
                        onConfirm={() => remove(item.name)}
                        okText={translation(translationCache, constant.yes)}
                        cancelText={translation(translationCache, constant.no)}
                      >
                        <Tooltip title={translation(translationCache, 'Delete')} placement="bottom">
                          <DeleteOutlined />
                        </Tooltip>
                      </Popconfirm>
                    }
                  >
                    <>
                      <StyledBox>
                        <Form.Item

                          label={translation(translationCache, constant.item)}
                          {...item}
                          name={[item.name, 'ItemId']}
                          fieldKey={[item.fieldKey, 'ItemId']}
                          key={index2}
                          rules={[{ required: true, message: 'item Missing' }]}
                        >
                          <Select
                            style={{ width: '100%' }}
                            onChange={(value) =>
                              props.onItemChange(
                                value,
                                props.fieldKey,
                                item.key,
                                'Items',
                                itemsList.filter((tool) => tool.Id === value)
                              )
                            }
                            placeholder={translation(translationCache, 'Select Item')}
                          >
                            {itemsList.map((item, index) => {
                              return (
                                <Option
                                  key={index}
                                  value={item.Id}
                                  disabled={
                                    props && props.selectedTab && props.selectedTab !== '2'
                                      ? props &&
                                        props.formObject &&
                                        props.formObject.TaskData &&
                                        props.formObject.TaskData[props.fieldKey] &&
                                        props.formObject.TaskData[props.fieldKey]['Items'] &&
                                        props.formObject.TaskData[props.fieldKey]['Items'].filter(
                                          (val) => val && val.ItemId === item.Id
                                        ).length > 0
                                        ? true
                                        : false
                                      : props &&
                                        props.formObject &&
                                        props.formObject.ActualTaskData &&
                                        props.formObject.ActualTaskData[props.fieldKey] &&
                                        props.formObject.ActualTaskData[props.fieldKey]['Items'] &&
                                        props.formObject.ActualTaskData[props.fieldKey][
                                          'Items'
                                        ].filter((val) => val && val.ItemId === item.Id).length > 0
                                        ? true
                                        : false
                                  }
                                >
                                  {' '}
                                  {translation(translationCache, item.Item)}{' '}
                                </Option>
                              );
                            })}
                          </Select>
                        </Form.Item>
                        <Form.Item

                          label={translation(translationCache, constant.description)}
                          {...item}
                          name={[item.name, 'Description']}
                          fieldKey={[item.fieldKey, 'Description']}
                          key={index2}
                          rules={[{ required: false, message: 'Value Missing' }]}
                        >
                          <InputComponent
                            placeholder={translation(translationCache, 'Description')}
                            style={{ width: '100%' }}
                            disabled
                          />
                        </Form.Item>
                       
                        {props && props.selectedTab && props.selectedTab === '1' ? (
                          <Form.Item

                            label={translation(translationCache, constant.Quantity)}
                            {...item}
                            validateTrigger={['onChange', 'onBlur']}
                            name={[item.name, 'Quantity']}
                            fieldKey={[item.fieldKey, 'Quantity']}
                            key={index2}
                            rules={[
                              { required: false, message: 'Please Input Numbers Only' },

                              {
                                validator: (_, value) =>
                                  checkTask(
                                    _,
                                    value,
                                    'Items',
                                    item.key,
                                    props.formObject.TaskData[props.fieldKey],
                                    { validateDecimal: true }
                                  )
                              }
                            ]}
                          >
                            <InputNumberComponent
                              //maxLength={10}
                              placeholder={translation(translationCache, 'Enter Quantity')}
                              style={{ width: '100%' }}
                              disabled={
                                (props &&
                                  props.formObject &&
                                  props.formObject.TaskData &&
                                  props.formObject.TaskData[props.fieldKey] &&
                                  props.formObject.TaskData[props.fieldKey].Items &&
                                  props.formObject.TaskData[props.fieldKey].Items[index2] ===
                                  null) ||
                                  (props &&
                                    props.formObject &&
                                    props.formObject.TaskData &&
                                    props.formObject.TaskData[props.fieldKey] &&
                                    props.formObject.TaskData[props.fieldKey].Items &&
                                    props.formObject.TaskData[props.fieldKey].Items[index2] ===
                                    undefined)
                                  ? true
                                  : false
                              }
                              addonAfter={
                                <Tooltip
                                  // style={{ flex: '50%' }}
                                  // labelCol={{ flex: '130px' }}
                                  title={translation(
                                    translationCache,
                                    'AvailableQuantity  -  ' +
                                    (props &&
                                      props.formObject &&
                                      props.formObject.TaskData &&
                                      props.formObject.TaskData[props.fieldKey] &&
                                      props.formObject.TaskData[props.fieldKey].Items &&
                                      props.formObject.TaskData[props.fieldKey].Items[index2] &&
                                      props.formObject.TaskData[props.fieldKey].Items[index2]
                                        .AvailableQuantity
                                      ? props.formObject.TaskData[props.fieldKey].Items[index2]
                                        .AvailableQuantity
                                      : 'Not Available')
                                  )}
                                >
                                  <QuestionCircleOutlined style={{ fontSize: '25px' }} />
                                </Tooltip>
                              }
                            />
                          </Form.Item>
                        ) : (
                          <Form.Item

                            label={translation(translationCache, constant.Quantity)}
                            {...item}
                            validateTrigger={['onChange', 'onBlur']}
                            name={[item.name, 'Quantity']}
                            fieldKey={[item.fieldKey, 'Quantity']}
                            key={index2}
                            rules={[
                              { required: false, message: 'Please Input Numbers Only' },

                              {
                                validator: (_, value) =>
                                  checkTask(
                                    _,
                                    value,
                                    'Items',
                                    item.key,
                                    props.formObject.ActualTaskData[props.fieldKey],
                                    { validateDecimal: true }
                                  )
                              }
                            ]}
                          >
                            <InputNumberComponent
                              //maxLength={10}
                              placeholder={translation(translationCache, 'Enter Quantity')}
                              style={{ width: '100%' }}
                              disabled={
                                (props &&
                                  props.formObject &&
                                  props.formObject.ActualTaskData &&
                                  props.formObject.ActualTaskData[props.fieldKey] &&
                                  props.formObject.ActualTaskData[props.fieldKey].Items &&
                                  props.formObject.ActualTaskData[props.fieldKey].Items[index2] ===
                                  null) ||
                                  (props &&
                                    props.formObject &&
                                    props.formObject.ActualTaskData &&
                                    props.formObject.ActualTaskData[props.fieldKey] &&
                                    props.formObject.ActualTaskData[props.fieldKey].Items &&
                                    props.formObject.ActualTaskData[props.fieldKey].Items[index2] ===
                                    undefined)
                                  ? true
                                  : false
                              }
                              addonAfter={
                                <Tooltip
                                  // style={{ flex: '50%' }}
                                  // labelCol={{ flex: '130px' }}
                                  title={translation(
                                    translationCache,
                                    'AvailableQuantity  -  ' +
                                    (props &&
                                      props.formObject &&
                                      props.formObject.ActualTaskData &&
                                      props.formObject.ActualTaskData[props.fieldKey] &&
                                      props.formObject.ActualTaskData[props.fieldKey].Items &&
                                      props.formObject.ActualTaskData[props.fieldKey].Items[
                                      index2
                                      ] &&
                                      props.formObject.ActualTaskData[props.fieldKey].Items[index2]
                                        .AvailableQuantity
                                      ? props.formObject.ActualTaskData[props.fieldKey].Items[
                                        index2
                                      ].AvailableQuantity
                                      : 'Not Available')
                                  )}
                                >
                                  <QuestionCircleOutlined style={{ fontSize: '25px' }} />
                                </Tooltip>
                              }
                            />
                          </Form.Item>
                        )}
                        <Form.Item
                          name={[item.name, 'AvailableQuantity']}
                        >
                        </Form.Item>

                      </StyledBox>
                    </>
                  </Panel>
                ))}
              </Collapse>
            ) : null}
          </Fragment>
        );
      }}
    </Form.List>
  );
};
const FieldDataTypeFormFunction = (props) => {
  const [itemsList, setItem] = useState([]);
  const [translationCache, settranslationCache] = useState(props.translationCache || {});
  const [usersList, setUsersList] = useState([]);
  const [uomList, setUomList] = useState([]);
  const [formObject, setFormObject] = useState(props.formObject);
  const [fileUploadList, setFileUploadList] = useState({});
  const [Include, setInclude] = useState(props.Include);
  const AddInclude = props.AddTask;
  const workOrderJobPlanRef = props.workOrderJobPlanRef;
  const index = props.checkbox;

  useEffect(() => {
    (async () => {
      try {
        const usersList = await getUsersList();
        setUsersList(usersList);
      } catch (error) {
        message.warn(`${error.message}`);
      }
      try {
        const uomList = await _getUOMList();
        setUomList(uomList);
      } catch (error) {
        message.warn(`${error.message}`);
      }
    })();
  }, []);

  const taskFileupload = async (values, key, fileDataObject, index, TaskId) => {
    let currentFormObject = workOrderJobPlanRef.current.getFieldsValue();
    if (
      currentFormObject &&
      currentFormObject['FieldData'] &&
      currentFormObject['FieldData'][index] &&
      currentFormObject['FieldData'][index][key]
    ) {
      currentFormObject['FieldData'][index][key].push(...values);
    } else if (currentFormObject['FieldData'][index] !== undefined) {
      currentFormObject['FieldData'][index][key] = values;
    } else {
      currentFormObject['FieldData'].push({ [key]: values });
    }
    currentFormObject['FieldData'] = currentFormObject['FieldData'].map((item, idx) => {
      if (item[key]) {
        item[key] = item[key].reduce((acc, current) => {
          const x = acc.find((item) => item.Name === current.Name);
          if (!x) {
            return acc.concat([current]);
          } else {
            return acc;
          }
        }, []);
      }
      return item;
    });
    let updatedFormObject = {
      ...currentFormObject,
      [key]: currentFormObject[key]
    };
    let TaskData = [...(fileUploadList.TaskData || [])];
    TaskData.push({ fileDataObject, TaskId });
    setFileUploadList({
      ...fileUploadList,
      TaskData
    });
    workOrderJobPlanRef.current.setFieldsValue(updatedFormObject);
    setFormObject(updatedFormObject);
    props.fileUploadListBack(fileUploadList);
  };
  return (
    <Form.List name={[props.fieldKey, 'FieldDataType']}>
      {(FieldDataType, { add, remove }) => {
        return (
          <Fragment>
            <Form.Item>
              <div style={{ display: 'flex', justifyContent: 'right' }}>
                <Button
                  theme={themeSettings}
                  type="primary"
                  onClick={() => {
                    add();
                    if (AddInclude === true) {
                      setInclude(false);
                    } else {
                      setInclude(true);
                    }
                  }}
                >
                  {translation(translationCache, constant.addTasks)}
                </Button>
              </div>
            </Form.Item>
            {FieldDataType && Array.isArray(FieldDataType) && FieldDataType.length > 0 ? (
              <Collapse theme={themeSettings} accordion defaultActiveKey={[]}>
                {FieldDataType &&
                  Array.isArray(FieldDataType) &&
                  FieldDataType.map((item, index2) => {
                    return (
                      <Panel
                        key={index2}
                        header={
                          <div style={{ fontWeight: 'bold' }}>
                            {`${translation(translationCache, constant.FieldDataType)} ${index2 + 1
                              }`}
                          </div>
                        }
                        extra={
                          <Popconfirm
                            title={translation(translationCache, constant.deleteFdt)}
                            icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                            onConfirm={() => remove(item.name)}
                            okText={translation(translationCache, constant.yes)}
                            cancelText={translation(translationCache, constant.no)}
                          >
                            <Tooltip
                              title={translation(translationCache, 'Delete')}
                              placement="bottom"
                            >
                              <DeleteOutlined />
                            </Tooltip>
                          </Popconfirm>
                        }
                      >
                        <StyledBox>
                          <Form.Item
                            label={translation(translationCache, constant.Taskitem)}

                            {...item}
                            name={[item.name, 'Name']}
                            fieldKey={[item.fieldKey, 'Name']}
                            key={index2}
                            rules={[
                              {
                                required: true,
                                message: 'Task Item is Required'
                              }
                            ]}
                          >
                            <InputComponent
                              placeholder={translation(translationCache, 'Enter Task')}
                              // value={formObject.Name}
                              style={{ width: '100%' }}
                            //maxLength={30}
                            />
                          </Form.Item>
                          <Form.Item
                            label={translation(translationCache, 'Task Description')}
                            {...item}

                            name={[item.name, 'Description']}
                            fieldKey={[item.fieldKey, 'Description']}
                            key={index2}
                            rules={[
                              {
                                required: true,
                                message: 'Task Description is Required'
                              }
                            ]}
                          >
                            <InputComponent
                              placeholder={translation(translationCache, 'Enter Description')}
                              // value={formObject.Description}
                              style={{ width: '100%' }}
                            //maxLength={100}
                            />
                          </Form.Item>

                          <Form.Item
                            label={translation(translationCache, 'Measurement Value')}
                            {...item}

                            name={[item.name, 'MeasurementValue']}
                            fieldKey={[item.fieldKey, 'MeasurementValue']}
                            key={index2}
                          >
                            <InputComponent
                              placeholder={translation(translationCache, 'Enter Measurement Value')}
                              // value={formObject.MeasurementValue}
                              style={{ width: '100%' }}
                            //maxLength={30}
                            />
                          </Form.Item>
                          <Form.Item
                            label={translation(translationCache, 'Unit Of Measure ')}
                            {...item}

                            name={[item.name, 'UOM']}
                            fieldKey={[item.fieldKey, 'UOM']}
                            key={index2}
                          >
                            <Select
                              placeholder={translation(translationCache, 'Select UOM')}
                              style={{ width: '100%' }}
                            >
                              {uomList &&
                                Array.isArray(uomList) &&
                                uomList.map((uom, index) => {
                                  return (
                                    <Option key={index} value={uom.UOM}>
                                      {' '}
                                      {uom.UOM}{' '}
                                    </Option>
                                  );
                                })}
                            </Select>
                          </Form.Item>
                          <Form.Item
                            // style={{ width: '100%', flex: '50%' }}
                            label={translation(translationCache, constant.inspectionMethod)}
                            {...item}

                            name={[item.name, 'Method']}
                            fieldKey={[item.fieldKey, 'Method']}
                            key={index2}
                          >
                            <InputComponent
                              placeholder={translation(translationCache, 'Enter Inspection Method')}
                              // value={formObject.InspectionMethod}
                              style={{ width: '100%' }}
                            //maxLength={30}
                            />
                          </Form.Item>
                          <Form.Item
                            label={translation(translationCache, constant.criterion)}
                            {...item}

                            name={[item.name, 'Criteria']}
                            fieldKey={[item.fieldKey, 'Criteria']}
                            key={index2}
                          >
                            <InputComponent
                              placeholder={translation(translationCache, 'Enter Criteria')}
                              // value={formObject.Criteria}
                              style={{ width: '100%' }}
                            //maxLength={30}
                            />
                          </Form.Item>
                          <Form.Item
                            label={translation(translationCache, constant.observation)}
                            {...item}

                            name={[item.name, 'Observation']}
                            fieldKey={[item.fieldKey, 'Observation']}
                            key={index2}
                          >
                            <InputComponent
                              placeholder={translation(translationCache, 'Enter Observation')}
                              // value={formObject.Observation}
                              style={{ width: '100%' }}
                            //maxLength={30}
                            />
                          </Form.Item>

                          <Form.Item
                            label={translation(translationCache, constant.recordedBy)}

                            {...item}
                            name={[item.name, 'RecordBy']}
                            fieldKey={[item.fieldKey, 'RecordBy']}
                            key={index2}
                          >
                            <Select
                              placeholder={translation(translationCache, 'Select RecordedBy')}
                              style={{ width: '100%' }}
                            >
                              {usersList &&
                                Array.isArray(usersList) &&
                                usersList.length > 0 &&
                                usersList.map((item, index) => {
                                  return (
                                    <Option key={index} value={item.Id}>
                                      {' '}
                                      {item.FirstName}{' '}
                                    </Option>
                                  );
                                })}
                            </Select>
                          </Form.Item>
                          {/* <Form.Item
                            
                            {...FieldDataType}
                          ></Form.Item> */}
                          {formObject &&
                            formObject.TaskData &&
                            formObject.TaskData[index] &&
                            formObject.TaskData[index].Id && (
                              <>
                                <Form.Item
                                  {...item}
                                  name={[item.name, 'AddJobplan']}
                                  valuePropName="checked"
                                >
                                  <Checkbox>
                                    {translation(translationCache, 'Include in JobPlan')}
                                  </Checkbox>
                                </Form.Item>

                                <Form.Item
                                  {...item}
                                  name={[item.name, 'AddTask']}
                                  valuePropName="checked"
                                >
                                  <Checkbox>
                                    {translation(translationCache, 'Include in Task')}
                                  </Checkbox>
                                </Form.Item>
                              </>
                            )}
                        </StyledBox>
                      </Panel>
                    );
                  })}
              </Collapse>
            ) : null}
          </Fragment>
        );
      }}
    </Form.List>
  );
};
const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
  };
};
const Toolsform = connect(mapStateToProps)(ToolsformFunction);
const LaborForm = connect(mapStateToProps)(LaborFormFunction);
const MaterialForm = connect(mapStateToProps)(MaterialFormFunction);
const ItemForm = connect(mapStateToProps)(ItemFormFunction);
const FieldDataType = connect(mapStateToProps)(FieldDataTypeFormFunction);
// const ObservationType = connect(mapStateToProps)(ObservationTypeFormFunction);
export { Toolsform, LaborForm, MaterialForm, ItemForm, FieldDataType };
